{
  "name": "assets",
  "version": "2.12.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "nx run-many --targets=serve",
    "start:old": "nx run-many --targets=serve --projects=asset-old --configuration=local",
    "start:old:dev": "nx run-many --targets=serve --projects=asset-old --configuration=dev",
    "start:old:homol": "nx run-many --targets=serve --projects=asset-old --configuration=homol",
    "start:new": "nx run asset-react:dev",
    "start:homol": "nx serve --configuration homol --port 4200 --watch=true",
    "build": "nx run asset-old:build --configuration=production --index=apps/asset-old/src/homes/index.html && nx run asset-react:build",
    "build:dev": "nx run asset-old:build --index=apps/asset-old/src/homes/dev/index.html && nx run asset-react:build",
    "build:hom": "nx run asset-old:build --configuration=homol --index=apps/asset-old/src/homes/homol/index.html && nx run asset-react:build",
    "build:prod": "nx run asset-old:build --configuration=production --index=apps/asset-old/src/homes/index.html && nx run asset-react:build",
    "test": "nx run asset-old:test --watch=false --code-coverage --browsers ChromeHeadlessNoSandbox",
    "test:old:ci": "nx run asset-old:test --watch=false --code-coverage --browsers ChromeHeadlessNoSandbox",
    "test:new:ci": "nx run asset-new:test --watch=false --code-coverage --browsers ChromeHeadlessNoSandbox",
    "test:old:local": "nx run asset-old:test --watch --source-map --code-coverage --browsers=Chrome",
    "test:new:local": "nx run asset-new:test --watch --source-map --code-coverage --browsers=Chrome",
    "lint": "nx lint",
    "sonar": "npm run test && sonar-scanner",
    "e2e": "npx playwright test --project=chrome --retries=3",
    "e2e:ci": "npx playwright test --project=chrome --reporter=junit --retries=1",
    "e2e:local": "npx playwright test --project=chrome --headed --retries=0",
    "e2e:local:dev": "npm run build:dev && npm run e2e:local",
    "e2e:local:hom": "npm run build:hom && npm run e2e:local",
    "e2e:local:prod": "npm run build:prod && npm run e2e:local",
    "e2e:debug": "npx playwright test --project=chrome --debug",
    "e2e:ui": "npx playwright test --project=chrome --ui",
    "e2e:codegen": "npx playwright codegen http://localhost:4200",
    "e2e:install": "npx playwright install chromium",
    "lint-fix": "nx lint --fix",
    "view-bundle": "esbuild-visualizer --metadata ./dist/webasset/stats.json"
  },
  "husky": {
    "hooks": {
      "pre-push": ""
    }
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "19.2.3",
    "@angular/cdk": "^16.2.14",
    "@angular/common": "19.2.3",
    "@angular/compiler": "19.2.3",
    "@angular/core": "19.2.3",
    "@angular/forms": "19.2.3",
    "@angular/localize": "19.2.3",
    "@angular/material": "^16.2.0",
    "@angular/platform-browser": "19.2.3",
    "@angular/platform-browser-dynamic": "19.2.3",
    "@angular/platform-server": "19.2.3",
    "@angular/router": "19.2.3",
    "@cucumber/cucumber": "^12.2.0",
    "@ids/angular": "1.57.3",
    "@ids/styles": "1.55.3",
    "@ids/styles-v2": "npm:@ids/styles@2.4.0",
    "@ids/tools": "^1.42.1",
    "@ids/web": "2.4.0",
    "@popperjs/core": "^2.11.8",
    "@quickweb/connect-angular": "^4.3.0",
    "@quickweb/mfe-context": "4.0.0",
    "@tailwindcss/vite": "^4.1.16",
    "@types/file-saver": "^2.0.7",
    "@types/selenium-webdriver": "^4.35.3",
    "blob-util": "^2.0.2",
    "bootstrap": "^5.3.8",
    "browser-sync": "^3.0.4",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "core-js": "^3.46.0",
    "crypto-js": "4.0.0",
    "cucumber": "^6.0.7",
    "dayjs": "^1.11.13",
    "domain-browser": "5.7.0",
    "express": "^5.1.0",
    "file-saver": "^2.0.5",
    "font-awesome": "^4.7.0",
    "guid-typescript": "^1.0.9",
    "jquery": "^3.7.1",
    "json2typescript": "^1.6.1",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.21",
    "lucide-angular": "^0.483.0",
    "moment": "^2.30.1",
    "ng-bullet": "^1.0.3",
    "ng2-currency-mask": "^13.0.3",
    "ngx-bootstrap": "^19.0.2",
    "ngx-mask": "^19.0.7",
    "ngx-papaparse": "^8.0.0",
    "popper.js": "^1.16.1",
    "process": "^0.11.10",
    "react": "19.2.0",
    "react-dom": "19.2.0",
    "react-router-dom": "7.9.5",
    "rxjs": "7.8",
    "scroll-behavior": "^0.11.0",
    "sonarqube-scanner": "^4.3.2",
    "stacktrace-js": "^2.0.2",
    "tailwind-merge": "^3.3.1",
    "tailwindcss-animate": "^1.0.7",
    "tslib": "^2.8.1",
    "util": "^0.12.5",
    "uuid": "^13.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "1.22.5",
    "@analogjs/vitest-angular": "1.22.5",
    "@angular-devkit/build-angular": "19.2.3",
    "@angular-devkit/core": "19.2",
    "@angular-devkit/schematics": "19.2",
    "@angular-eslint/eslint-plugin": "^19.2.1",
    "@angular-eslint/eslint-plugin-template": "^19.2.1",
    "@angular-eslint/template-parser": "^19.2.1",
    "@angular/cli": "19.2",
    "@angular/compiler-cli": "19.2.3",
    "@angular/language-service": "19.2.3",
    "@nx/angular": "22.0.4",
    "@nx/devkit": "22.0.4",
    "@nx/eslint": "22.0.4",
    "@nx/eslint-plugin": "22.0.4",
    "@nx/js": "22.0.4",
    "@nx/playwright": "22.0.4",
    "@nx/react": "22.0.4",
    "@nx/vite": "22.0.4",
    "@nx/web": "22.0.4",
    "@nx/workspace": "22.0.4",
    "@playwright/test": "^1.51.1",
    "@schematics/angular": "19.2",
    "@swc-node/register": "~1.11.1",
    "@swc/cli": "0.7.8",
    "@swc/core": "~1.14.0",
    "@swc/helpers": "~0.5.17",
    "@tailwindcss/postcss": "^4.1.16",
    "@testing-library/dom": "10.4.1",
    "@testing-library/react": "16.3.0",
    "@types/chai": "^5.2.3",
    "@types/chai-as-promised": "^8.0.2",
    "@types/crypto-js": "^4.2.2",
    "@types/cucumber": "^7.0.3",
    "@types/eslint": "^9.6.1",
    "@types/jasmine": "^5.1.12",
    "@types/jasminewd2": "^2.0.13",
    "@types/node": "^24.10.0",
    "@types/react": "19.2.2",
    "@types/react-dom": "19.2.2",
    "@typescript-eslint/eslint-plugin": "^8.46.2",
    "@typescript-eslint/parser": "^8.46.2",
    "@typescript-eslint/utils": "^8.46.2",
    "@vitejs/plugin-react": "^5.1.0",
    "@vitest/coverage-v8": "^4.0.6",
    "@vitest/ui": "^4.0.6",
    "autoprefixer": "10.4.21",
    "babel-plugin-react-compiler": "1.0.0",
    "cors": "^2.8.5",
    "dotenv": "^16.4.5",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "~9.39.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-import": "latest",
    "eslint-plugin-jsdoc": "latest",
    "eslint-plugin-prefer-arrow": "latest",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-sonarjs": "~3.0.5",
    "gulp": "5.0.1",
    "husky": "^9.1.7",
    "intl": "^1.2.5",
    "jasmine-core": "^5.12.1",
    "jasmine-spec-reporter": "^7.0.0",
    "jiti": "2.6.1",
    "jsdom": "~27.1.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-spec-reporter": "^0.0.36",
    "karma-threshold-reporter": "^0.1.15",
    "karma-typescript": "^5.5.4",
    "nx": "22.0.4",
    "postcss": "^8.5.6",
    "prettier": "^3.6.2",
    "rimraf": "^6.0.1",
    "sonarqube-scanner": "^4.3.2",
    "tailwindcss": "^4.1.16",
    "ts-node": "^10.9.2",
    "tslint-sonarts": "^1.9.0",
    "typescript": "5.7.2",
    "vite": "^7.1.12",
    "vite-plugin-dts": "~4.5.4",
    "vitest": "^4.0.6"
  }
}
